import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FaqPanelComponent } from './faq-panel.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { RouterModule } from '@angular/router';

@NgModule({
  declarations: [FaqPanelComponent],
  exports: [FaqPanelComponent],
  imports: [
    CommonModule,
    SharedModule,
    RouterModule
  ],
})
export class FaqPanelModule { }
